import { render, staticRenderFns } from "./CustomizeWhitelabelForm.vue?vue&type=template&id=7786f89b&"
import script from "./CustomizeWhitelabelForm.vue?vue&type=script&lang=js&"
export * from "./CustomizeWhitelabelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports